import { defaultsDeep } from "lodash";
import { DeepNullableObj, MedicalDiagnosis } from "../types";
import { MockFn, createMock } from "./index";

const mockMedicalDiagnosis: MockFn<
  Partial<DeepNullableObj<MedicalDiagnosis>>
> = (args) =>
  defaultsDeep(
    args,
    createMock(
      "MedicalDiagnosis",
      args,
      (): DeepNullableObj<MedicalDiagnosis> => ({
        addictions: null,
        additional_examinations_necessary: null,
        additional_icd_codes: null,
        allergies: null,
        chronic_pains: null,
        corona: { description: null, test_result: null, vaccinated: null },
        corona_state: null,
        dependency_diagnosis: {
          agitated: null,
          agitated_description: null,
          barthel_assessment: {
            date: null,
            form: {
              bathing: null,
              dressing_and_undressing: null,
              fecal_incontinence: null,
              food: null,
              getting_up_and_walking: null,
              personal_care: null,
              setting_up_and_relocating: null,
              stair_climbing: null,
              toilet_use: null,
              urinary_incontinence: null,
            },
            score: null,
          },
          dependency_level: null,
          early_rehab_assessment: {
            date: null,
            form: {
              behavioural_disorder: null,
              intensive_medical_monitoring: null,
              intermittent_ventilation: null,
              orientation_disorder: null,
              severe_communication_disorder: null,
              supervised_swallowing_disorder: null,
              tracheostoma_requiring_aspiration: null,
            },
            score: null,
          },
          has_help_at_home: null,
          requires_support_with_feeding: null,
          requires_walking_aid: null,
          returning_home_short_term: null,
          singer_assessment: {
            date: null,
            form: {
              concentration: null,
              domestic_life_household: null,
              dressing_and_undressing: null,
              food: null,
              hygiene: null,
              listening: null,
              orientation: null,
              planning: null,
              reading: null,
              shower: null,
              social_interaction: null,
              stairs: null,
              stool: null,
              talking: null,
              toilet_use: null,
              transfer: null,
              urination: null,
              walking: null,
              wheelchair: null,
              writing: null,
            },
            score: null,
          },
        },
        dysphagia: null,
        hl7_diagnoses: null,
        hl7_main_diagnoses: null,
        hl7_secondary_diagnoses: null,
        hospital_stay: {
          doctor_in_charge_in_hospital: null,
          doctor_in_charge_in_hospital_phone: null,
          geriatric_early_stage: null,
          operation_date: null,
          operation_description: null,
        },
        icd_code: null,
        infection_and_germs: {
          clostridien: null,
          four_mrgn: null,
          mrsa: null,
          other: null,
          remarks: null,
          requires_isolation: null,
          three_mrgn: null,
          vre: null,
        },
        infection_and_germs_state: null,
        limited_capacity: {
          limited_cognitive_capacity: null,
          limited_physical_capacity: null,
          limited_psychological_capacity: null,
          limited_social_behaviour: null,
          other: null,
        },
        main_diagnosis: null,
        medical_history: null,
        mental_health: {
          aggressivity: null,
          anxiety: null,
          closed_station: null,
          communication: null,
          dangerous: null,
          dementia_description: null,
          depression: null,
          fixation: null,
          mental_issues: null,
          motivation: null,
          night_watch_description: null,
          orientation: null,
          protected_area_needed: null,
          run_away_description: null,
          vigilance: null,
        },
        multimorbidity: null,
        palliative: { description: null, palliative_certificate_needed: null },
        physical_disabilities: {
          assistive_equipment: null,
          auditive_impairment: null,
          existing_medical_supplies: null,
          load_carrying_ability: null,
          mobility: null,
          mobility_additional_information: null,
          orthese: null,
          prescribed_medical_supplies: null,
          prothese: null,
          required_medical_supplies: null,
          visual_impairment: null,
        },
        rehabilitation_goals: null,
        rehabilitation_potential: { description: null, evaluation: null },
        secondary_diagnosis: null,
      }),
    ),
  );

export default mockMedicalDiagnosis;
